import type { AxiosResponse } from 'axios';
import { useMutation } from 'react-query';
import { useRouteMatch } from 'react-router-dom';

import { trackEvent } from '@/analytics/trackEvent';
import { SOURCE_API_ROUTES } from '@/api-routes';
import { axiosInstance } from '@/axios';
import { useInvalidatePublicApps } from '@/hooks/query/useFetchPublicApps';
import type { Priority, RssSource } from '@/types';

import { useRefetchWebsite } from './useFetchWebsite';

type RequestPayload = {
  source_id: string;
  priority: Priority;
};

export const useUpdateRSSPriority = () => {
  const refetchWebsite = useRefetchWebsite();
  const refetchPublicApps = useInvalidatePublicApps();
  const match = useRouteMatch(['/feeds', '/connect/rss']);

  return useMutation<AxiosResponse, unknown, RssSource>(
    ({ source_id, priority }: RequestPayload) =>
      axiosInstance.put(SOURCE_API_ROUTES.rssInfo(source_id), {
        priority: priority,
      }),
    {
      onSuccess: (_, variables) => {
        trackEvent('website_priority', {
          source: variables.source_id,
          priority: true,
          path: match?.path === '/feeds' ? 'feeds' : 'rss_manager',
        });
      },
      onSettled: (_, __, { source_id }) => {
        refetchWebsite(source_id);
        refetchPublicApps();
      },
    }
  );
};
